export const CATERING_PT_BR = {
	title: "Catering",
	description:
		"Gerencie o catering dos seus eventos, receba propostas, envie orçamentos e monitore tudo em um lugar.",
	tabs: {
		proposals: "Propostas",
		settings: "Configurações",
	},
	settingsMenu: {
		proposalOptions: "Opções de Propostas",
		servicesAndFormats: "Serviços e formatos",
	},
	feedback: {
		saveSuccess: "Alterações salvas. As mudanças serão aplicadas em novas propostas.",
		saveError:
			"Não foi possível salvar as alterações. Tente novamente em alguns instantes.",
	},
	proposalOptions: {
		style: {
			title: "Estilo da proposta",
			description: "Personalize e deixe sua proposta com a cara da sua empresa.",
		},
		company: {
			label: "Sobre a empresa",
			companyLabel: "Empresa",
			editAria: "Editar dados da empresa",
		},
		infoBlocks: {
			label: "Blocos de informação padrão",
			showLabel: "Exibir",
			editAria: "Editar {{name}}",
			disabledHint: "Cadastre os dados da empresa antes de configurar este bloco.",
			header: "Cabeçalho",
			footer: "Rodapé",
			payment: "Meios e condições de pagamento",
		},
		templates: {
			title: "Modelos de propostas salvos",
			description: "Gerencie e edite suas propostas modelo.",
			addLabel: "Adicionar modelo",
			emptyMessage: "Nenhum modelo cadastrado",
			createdAt: "Criado em {{date}}",
			editAria: "Editar {{name}}",
		},
	},
	editHeader: {
		title: "Personalizar cabeçalho",
		createTitle: "Criar cabeçalho",
		saveLabel: "Salvar estilo",
		fields: {
			title: {
				label: "Título",
				placeholder: "Ex.: Proposta Comercial",
			},
			showSubmissionDate: "Mostrar data do dia de envio e local",
			showCompanyName: "Mostrar nome da empresa solicitante",
			showRepresentativeName: "Mostrar nome do representante da empresa",
			text: {
				label: "Texto inicial",
				placeholder:
					"Ex.: Prezados clientes, apresentamos abaixo a proposta comercial conforme cronograma do evento.",
				counter: "{{count}}/{{max}} caracteres",
			},
		},
	},
	editFooter: {
		title: "Personalizar rodapé",
		createTitle: "Criar rodapé",
		saveLabel: "Salvar estilo",
		fields: {
			text: {
				label: "Texto final",
				placeholder:
					"Ex.: Agradecemos seu interesse e nos colocamos a disposição para tirar eventuais dúvidas.",
				counter: "{{count}}/{{max}} caracteres",
			},
			showResponsibleName: "Mostrar nome do responsável pelo envio da proposta",
			showProposalValidity: "Mostrar validade da proposta",
		},
	},
	editPayment: {
		title: "Personalizar formas e condições de pagamento",
		createTitle: "Criar formas e condições de pagamento",
		saveLabel: "Salvar estilo",
		methods: {
			creditCard: "Cartão de crédito",
			debitCard: "Cartão de débito",
			boleto: "Boleto bancário",
			pix: "PIX",
			cash: "Dinheiro",
		},
		fields: {
			methods: {
				label: "Formas de pagamento aceitas",
			},
			text: {
				label: "Condições de pagamento",
				placeholder:
					"Ex.: Pagamento de 70% no fechamento da proposta e 30% em até 120 horas antes do evento;",
				counter: "{{count}}/{{max}} caracteres",
			},
		},
	},
	editCompany: {
		title: "Editar informações",
		createTitle: "Criar informações",
		saveLabel: "Salvar informações",
		errors: {
			invalidEmail: "E-mail inválido",
			invalidUrl: "Link inválido",
			requiredName: "Informe o nome da empresa",
		},
		sections: {
			info: "Informações da empresa",
			contacts: "Canais de contato",
			address: "Endereço",
		},
		fields: {
			name: {
				label: "Nome",
				placeholder: "Digite o nome da empresa",
			},
			cnpj: {
				label: "CNPJ",
				placeholder: "00.000.000/0000-00",
			},
			site: {
				label: "Site",
				placeholder: "Insira o link do site",
			},
			logo: {
				label: "Marca",
				cta: "Adicionar logo",
				help: "Tipo de arquivo JPG ou PNG com 300x105px.",
			},
			primaryColor: {
				label: "Cor principal",
				help: "Escolha a cor que será aplicada em ícones, textos e botões.",
				placeholder: "#000000",
			},
			mainPhone: {
				label: "Telefone principal",
				placeholder: "(27) 99999-0000",
			},
			secondaryPhone: {
				label: "Telefone secundário",
				placeholder: "(27) 99999-0000",
			},
			whatsapp: {
				label: "WhatsApp",
				placeholder: "whatsapp.we/9128394",
			},
			email: {
				label: "E-mail",
				placeholder: "contato@empresa.com.br",
			},
			socialMedia: {
				label: "Rede social",
				placeholder: "instagram/empresa",
			},
			zipCode: {
				label: "CEP",
				placeholder: "Digite o CEP",
			},
			street: {
				label: "Endereço",
				placeholder: "Nome da rua, avenida ou logradouro",
			},
			number: {
				label: "Número",
				placeholder: "Número",
			},
			complement: {
				label: "Complemento",
				placeholder: "Complemento",
			},
		},
	},
	proposalList: {
		filters: {
			searchPlaceholder: "Buscar por propostas",
			statusPlaceholder: "Todos os status",
			placePlaceholder: "Todos os places",
		},
		columns: {
			representative: "Representante da empresa",
			place: "Place",
			sentBy: "Enviado por",
			startsAt: "Inicia em",
			servicesCount: "Serviços",
			servicesTotal: "Valor",
			status: "Status",
		},
		status: {
			accepted: "Aceita",
			newResponse: "Nova resposta",
			draft: "Rascunho",
			sent: "Enviada",
			sendFailed: "Falha no envio",
			rejected: "Recusada",
		},
		emptyMessage: "Nenhuma proposta encontrada",
	},
	servicesAndFormats: {
		itemsCount: {
			one: "{{count}} item",
			other: "{{count}} itens",
		},
		drawerHelperText: "Pressione Enter para adicionar à lista.",
		services: {
			title: "Serviços cadastrados",
			description: "Gerencie e cadastre serviços para uso na criação de propostas.",
			addLabel: "Adicionar serviço",
			emptyMessage: "Nenhum serviço cadastrado",
			drawer: {
				title: "Adicionar novo serviço",
				inputLabel: "Nome do serviço",
				inputPlaceholder: "Digite o nome do novo serviço",
				saveLabel: "Salvar serviço",
			},
			notifications: {
				created: "Serviço(s) cadastrado(s) com sucesso.",
				createdPartial: "{{ok}} serviço(s) cadastrado(s), {{failed}} com falha.",
				createFailed: "Não foi possível cadastrar os serviços.",
				deleted: "Serviço removido com sucesso.",
				deleteFailed: "Não foi possível remover o serviço.",
			},
		},
		formats: {
			title: "Formatos cadastrados",
			description: "Gerencie e cadastre formatos para uso na criação de propostas.",
			addLabel: "Adicionar formato",
			emptyMessage: "Nenhum formato cadastrado",
			drawer: {
				title: "Adicionar novo formato",
				inputLabel: "Nome do formato",
				inputPlaceholder: "Digite o nome do novo formato",
				saveLabel: "Salvar formato",
			},
			notifications: {
				created: "Formato(s) cadastrado(s) com sucesso.",
				createdPartial: "{{ok}} formato(s) cadastrado(s), {{failed}} com falha.",
				createFailed: "Não foi possível cadastrar os formatos.",
				deleted: "Formato removido com sucesso.",
				deleteFailed: "Não foi possível remover o formato.",
			},
		},
	},
};

export type CateringTranslations = typeof CATERING_PT_BR;
